import { memo, SyntheticEvent, useCallback, useState, useRef } from 'react';
import styled from '@emotion/styled';
import { ChromePicker, ColorChangeHandler } from 'react-color';

import TextField from '../TextField';
import Icon from '../Icon';
import Popover from '../Popover';
import { fontSize, spacing } from 'presentations/views/styles';
import { black, gray01, white } from 'presentations/views/styles/color';

export interface Props {
  size?: 'small' | 'medium' | undefined;
  defaultValue?: string | null;
  value?: string;
  onChange: (newValue: string) => void;
}

const Component = memo((props: Props) => {
  const containerRef = useRef<any>(null);
  const [anchor, setAnchor] = useState<any>(null);

  const onChange: ColorChangeHandler = useCallback(
    (color, e) => {
      props.onChange(color.hex);
    },
    [props.onChange],
  );
  const onClick = useCallback((e: SyntheticEvent) => {
    setAnchor(containerRef.current);
  }, []);
  const onClose = useCallback(() => {
    setAnchor(null);
  }, []);

  return (
    <Container>
      <StyledTextField
        size={props.size || 'small'}
        value={props.value}
        suffix={<Icon name="palette" size={fontSize(18)} />}
        onClick={onClick}
        isDisabled
        inputRef={containerRef}
      />
      {anchor && (
        <Popover
          onClose={onClose}
          anchor={anchor}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <ChromePicker color={props.value} onChange={onChange} disableAlpha />
        </Popover>
      )}
    </Container>
  );
});

export default Component;

const Container = styled.div``;
const StyledTextField = styled(TextField)`
  cursor: pointer;
  width: 100px;
  height: 34px;
  background-color: ${white};
  color: ${gray01};

  & .MuiInputBase-root.Mui-disabled {
    color: ${black};
  }
  & .MuiIconButton-root.Mui-disabled {
    color: ${black};
    background-color: initial;
  }
  & .MuiInputBase-input {
    padding-left: ${spacing(8)};
    font-size: ${fontSize(13)};
  }
  & .MuiOutlinedInput-adornedEnd {
    padding-right: ${spacing(8)};
  }
  & .MuiInputAdornment-positionEnd {
    margin-top: ${spacing(3)};
    margin-left: 0;
  }
`;
